import { render, staticRenderFns } from "./notifyPage.vue?vue&type=template&id=254b8b12&scoped=true&"
import script from "./notifyPage.vue?vue&type=script&lang=js&"
export * from "./notifyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b8b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('254b8b12')) {
      api.createRecord('254b8b12', component.options)
    } else {
      api.reload('254b8b12', component.options)
    }
    module.hot.accept("./notifyPage.vue?vue&type=template&id=254b8b12&scoped=true&", function () {
      api.rerender('254b8b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifyPage.vue"
export default component.exports